var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseEmptyState',{attrs:{"title":"Não há nenhuma tabela de frete criada","subtitle":"Você ainda não criou nenhuma tabela de frete. Comece agora criando a primeira.","button-text":"Nova tabela","button-aria-label":"Criar nova tabela de frete","show-button":_vm.canCreate},on:{"action":function($event){return _vm.$emit('create')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }